import React from 'react';
import { Link } from 'react-router-dom';

const CampaignsCard = () => (
    <div className="priority-card accent-blue">
        <div className="action-row">
            <div>
                <h3
                    style={{
                        fontFamily: "'New Amsterdam', sans-serif",
                        fontSize: '1.3rem',
                        letterSpacing: '1px',
                        color: '#212529',
                        margin: 0,
                    }}
                >
                    Campaigns
                </h3>
                <div className="action-detail">
                    Win series to earn packs and exclusive titanium-tier cards.
                </div>
            </div>
            <Link to="/campaigns" className="card-cta blue">
                Play Campaigns
            </Link>
        </div>
    </div>
);

export default CampaignsCard;
